import { render, staticRenderFns } from "./SidebarComponents.vue?vue&type=template&id=6c30ca54"
import script from "./SidebarComponents.vue?vue&type=script&lang=js"
export * from "./SidebarComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports